export default "__VITE_ASSET__7MWibiBy__"